import { useConsent } from '@/lib/consent';
import { isSnapchatConfigured } from './client';

/** Consent-aware Snapchat enablement: true only when consent allows and env config is valid. */
export const useSnapchatEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isSnapchatConfigured();
};
